import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";
import { heroFadeUp, heroScaleIn } from "@/lib/animations";

const HeroContent = () => (
  <motion.div {...heroFadeUp}>
    <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-[#E5EAF2] shadow-[0_2px_8px_rgba(15,23,42,0.04)] text-xs font-bold uppercase tracking-[0.18em] text-[#3787F5]">
      <Sparkles size={14} className="text-[#12DDB5]" strokeWidth={2.4} />
      Processo seletivo Previsa Saúde
    </span>

    <h1 className="mt-6 text-[2.35rem] leading-[1.05] sm:text-5xl lg:text-[3.4rem] font-extrabold text-[#1F2937] tracking-[-0.025em]">
      Enfermeiro(a) Administrativo: faça parte da equipe que está{" "}
      <span className="text-gradient-brand">
        transformando a gestão em saúde
      </span>
    </h1>

    <p className="mt-6 text-lg text-[#64748B] leading-relaxed max-w-xl">
      A Previsa Saúde está ampliando sua equipe e busca{" "}
      <strong className="text-[#1F2937]">Enfermeiro(a) Administrativo</strong>{" "}
      para atuar com Entrevista Médica Qualificada, análise técnica de
      informações de saúde e apoio à gestão de risco assistencial.
    </p>

    <div className="mt-8 flex flex-col sm:flex-row gap-4">
      <a
        data-testid="hero-apply-btn"
        href="#candidatura"
        className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-gradient-to-r from-[#3532B3] to-[#3787F5] text-white font-semibold shadow-[0_12px_28px_rgba(53,50,179,0.28)] hover:shadow-[0_14px_36px_rgba(53,50,179,0.38)] hover:-translate-y-0.5 transition-all duration-300"
      >
        Quero me candidatar
        <ArrowRight size={18} strokeWidth={2.2} />
      </a>
      <a
        data-testid="hero-req-btn"
        href="#requisitos"
        className="inline-flex items-center justify-center px-7 py-4 rounded-full bg-white text-[#1F2937] font-semibold border border-[#E5EAF2] hover:border-[#3787F5] hover:text-[#3532B3] hover:bg-[#F6F8FB] transition-all duration-300"
      >
        Ver requisitos
      </a>
    </div>

    <p className="mt-5 text-sm text-[#64748B]">
      Vaga para atuação administrativa, auditoria em saúde e entrevista
      qualificada.
    </p>
  </motion.div>
);

const HeroVisual = () => (
  <motion.div {...heroScaleIn} className="relative">
    <div className="relative rounded-[2rem] overflow-hidden shadow-[0_30px_80px_rgba(53,50,179,0.18)] border border-white">
      <img
        src="https://static.prod-images.emergentagent.com/jobs/9516d585-db33-41dd-94ff-d4c6db66b9ab/images/c9211aba7b86f182b3715453e1ec69947d764d696b5119fb5ba158cac68945bd.jpeg"
        alt="Equipe diversa de atendimento em escritório moderno"
        className="w-full h-[460px] md:h-[540px] object-cover"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-tr from-[#3532B3]/45 via-[#3787F5]/10 to-transparent" />
    </div>
  </motion.div>
);

export const JobHero = () => (
  <section
    id="a-vaga"
    data-testid="job-hero"
    className="relative pt-32 md:pt-40 pb-16 overflow-hidden"
  >
    <div className="blob w-[480px] h-[480px] -top-32 -left-32 bg-[#3787F5]/30" />
    <div className="blob w-[420px] h-[420px] top-20 right-0 bg-[#12DDB5]/25" />

    <div className="relative max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-14 items-center">
      <HeroContent />
      <HeroVisual />
    </div>
  </section>
);
